import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { Button, FormBox } from "@impero-com/ui";

import { FormComponentProps, subForm } from "utils/form";

import { UserGroupDetailsEditor } from "../editor";

import { UserGroupCreateDetailsFields, UserGroupCreatorValues } from ".";

interface UserGroupCreatorDetailsStepProps extends FormComponentProps<
    "details",
    UserGroupCreateDetailsFields,
    UserGroupCreatorValues
> {
    onNext: () => void;
    onCancel: () => void;
}

class UserGroupCreatorDetailsStepComp extends React.PureComponent<UserGroupCreatorDetailsStepProps> {
    render = () => {
        const { form } = this.props;
        const { getFieldsError } = subForm("details", form);

        return (
            <FormBox>
                <UserGroupDetailsEditor type="CREATE" form={form} />
                <Button
                    disabled={this.hasErrors(getFieldsError() as object)}
                    id="user-group-details-next"
                    variant="primary"
                    onClick={this.nextStep}
                >
                    {t("Next")}
                </Button>
                <Button
                    variant="link"
                    id="user-group-details-cancel"
                    onClick={this.props.onCancel}
                >
                    {t("Cancel")}
                </Button>
            </FormBox>
        );
    };

    nextStep = () => {
        const { form } = this.props;
        const detailsForm = subForm("details", form);

        detailsForm.validateFields((errors: any, _validated: any) => {
            if (errors === null) {
                this.props.onNext();
            }
        });
    };

    hasErrors = (fieldsError: object): boolean => {
        const { form } = this.props;
        const detailsForm = subForm("details", form);
        const name = detailsForm.getFieldValue("name");

        if (!name) {
            return true;
        } else {
            return Object.values(fieldsError).some((err) => err);
        }
    };
}

export {
    type UserGroupCreatorDetailsStepProps,
    UserGroupCreatorDetailsStepComp as UserGroupCreatorDetailsStep,
};
